import Vue from 'vue';
import api from '../bu/api';
import Cookies from 'js-cookie';
import moment from 'moment';

export default {
    namespaced: true,

    state: () => ({
        hasInitedCustomer: false,
        customer: null,
        authError: null,
        showLoginBox: false,
        loginHint: '',
        timer: null,
    }),

    getters: {
        customer(state) {
            return state.customer;
        },
        authError(state) {
            return state.authError;
        },
        showLoginBox(state) {
            return state.showLoginBox;
        },
        loginHint(state) {
            return state.loginHint;
        },
        hasInitedCustomer(state) {
            return state.hasInitedCustomer;
        }
    },

    actions: {
        async initCustomer({ commit, dispatch }) {
            try {
                const response = await api.getLoggedInCustomer();
                if (response.data.customer) {
                    commit('setCustomer', response.data.customer);
                    commit('startTimer');
                    const currency = response.data.customer.currency;
                    if (currency) {
                        dispatch('currencies/setCurrency', currency, { root: true });
                    }
                }
            } catch (e) {
            } finally {
                commit('setHasInitedCustomer', true);
            }
        },
        async getLoggedInCustomer({ commit, dispatch }) {
            try {
                const response = await api.getLoggedInCustomer();
                if (response.data.customer) {
                    commit('setCustomer', response.data.customer);
                    commit('startTimer');
                    const currency = response.data.customer.currency;
                    if (currency) {
                        dispatch('currencies/setCurrency', currency, { root: true });
                    }
                }
            } catch (e) {
            }
        },
        async login({ commit, dispatch }, { phoneNumber, phoneCallingCode, password }) {
            const response = await api.login(phoneNumber, phoneCallingCode, password);
            if (response.data.customer) {
                commit('setCustomer', response.data.customer);
                commit('startTimer');
                const currency = response.data.customer.currency;
                if (currency) {
                    dispatch('currencies/setCurrency', currency, { root: true });
                }
            } else {
                commit('setAuthError', 'failed');
            }
        },
        async updateLoggedInCustomer({ commit }, { name, email, unbind_platforms,password, gender, ageGroup, currency }) {
            const response = await api.updateLoggedInCustomer(name, email, unbind_platforms, password, gender, ageGroup, currency);
            if (response.data.customer) {
                commit('setCustomer', response.data.customer);
            } else {
                commit('setAuthError', 'failed');
            }
        },
        async verifyAndLogIn({ commit }, { code, phoneNumber, phoneCallingCode, name, email, password, continueWithoutSmsVerification }) {
            const response = await api.verifyAndLogIn({
                code,
                phoneNumber,
                phoneCallingCode,
                name,
                email,
                password,
                continueWithoutSmsVerification,
            });
            if (response.data.customer) {
                commit('setCustomer', response.data.customer);
                commit('startTimer');
            } else {
                commit('setAuthError', 'failed');
            }
        },
        async logOutCustomer({commit}) {
            await api.logOutCustomer();
            commit('setCustomer', null);
            commit('clearTimer');
        },
        openLoginBox({commit}, loginHint) {
            commit('openLoginBox', loginHint);
        },
        closeLoginBox({commit}) {
            commit('closeLoginBox');
        },
        setLoginWithBookingCookie({commit}) {
            commit('setLoginWithBookingCookie');
        },
    },

    mutations: {
        setHasInitedCustomer(state, hasInitedCustomer) {
            Vue.set(state, 'hasInitedCustomer', hasInitedCustomer);
        },
        setCustomer(state, customer) {
            Vue.set(state, 'customer', customer);
        },
        setAuthError(state, authError) {
            Vue.set(state, 'authError', authError);
        },
        openLoginBox(state, loginHint) {
            Vue.set(state, 'showLoginBox', true);
            if (loginHint) {
                Vue.set(state, 'loginHint', loginHint);
            }
        },
        closeLoginBox(state) {
            Vue.set(state, 'showLoginBox', false);
            Vue.set(state, 'loginHint', '');
        },
        startTimer(state) {
            if (state.timer) {
                clearInterval(state.timer);
            }
            state.timer = setInterval(() => {
                const dingSessionCookie = Cookies.get('ding_session');
                if (!dingSessionCookie) {
                    alert('您的登入已逾時，請重新登入');
                    clearInterval(state.timer);
                    window.location = '/';
                }
            }, 1000);
        },
        clearTimer(state) {
            if (state.timer) {
                clearInterval(state.timer);
            }
        },
        setLoginWithBookingCookie() {
            const expireAt = moment().add(10, 'minutes').toDate();
            Cookies.set('login_with_booking', true, { expires: expireAt, path: '/' });
        },
    },
}
